import styled, {css} from "styled-components"
import {Col} from "react-bootstrap"

interface StyledColProps {
  withImage?: boolean
  alignTop?: boolean
}

const StyledCol = styled(Col)<StyledColProps>`
  ${({theme, withImage, alignTop}) => css`
    border-radius: ${theme.spacing.one};
    box-shadow: ${theme.shadows.mid};
    float: none;
    max-width: 480px;
    position: relative;
    padding: 0;
    margin: ${withImage ? "84px" : theme.spacing.four} auto 0 auto;
    ${theme.mediaQueries.minWidthMedia.tablet`
      margin: ${!alignTop ? "116px" : theme.spacing.four} auto 0 auto;
    `}
  `}
`

export default StyledCol
